import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { Observable, from } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(private toastr: ToastrService) { }

  showSuccessAlert(title: string, message: string = ''){
    Swal.fire({
      icon: 'success',
      title: title,
      text: message,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: 'black'
    });
  }

  showErrorAlert(title: string, message: string = ''){
    Swal.fire({
      icon: 'error',
      title: title,
      text: message,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: 'black'
    });
  }

  showWarningAlert(title: string, message: string = ''){
    Swal.fire({
      icon: 'warning',
      title: title,
      text: message,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: 'black'
    });
  }

  showInfoAlert(title: string, message: string = ''){
    Swal.fire({
      icon: 'info',
      title: title,
      text: message,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: 'black'
    });
  }

  showConfirmDialog(title: string, message: string, confirmButtonText: string = 'Confirmar', cancelButtonText: string = 'Cancelar'): Observable<boolean> {
    return from(Swal.fire({
      title: title,
      text: message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: confirmButtonText,
      cancelButtonText: cancelButtonText
    }).then((result) => {
      return result.isConfirmed;
    }));
  }
}
